import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getParameterGroup,
  getParameter,
  createParameterGroup,
  createParameter,
  getIdParameterGroup,
  getIdParameter,
  updateParameter,
  updateParameterGroup,
  getBusinessGroup,
  updateBusinessGroup,
  getTz,
  getNumberSequence,
  createNumberSequence,
  getIdNumberSequence,
  updateNumberSequence,
  deleteSequence,
  uploadImage,
  deleteImage,
  // deleteById,
} from "./businessGroupAPI";

const initialState = {
  data: null,
  loading: false,
  error: null,
  pageNo: 1,
  pageSize: 10,
  totalRecord: 0,
  selected: null,
  result: null,
  dataTz: [],
  dataSequence: [],
  dataIdSequence: null,
};

export const fetchBusinessGroup = createAsyncThunk(
  "businessGroup/fetchBusinessGroup",
  async (payload) => {
    const response = await getBusinessGroup(payload);
    return response;
  }
);

export const fetchNumberSequence = createAsyncThunk(
  "businessGroup/fetchNumberSequence",
  async (payload) => {
    const response = await getNumberSequence(payload);
    return response;
  }
);

export const fetchIdNumberSequence = createAsyncThunk(
  "businessGroup/fetchIdNumberSequence",
  async (payload) => {
    const response = await getIdNumberSequence(payload);
    return response;
  }
);

export const fecthTz = createAsyncThunk(
  "businessGroup/fecthTz",
  async (payload) => {
    const response = await getTz(payload);
    return response;
  }
);

export const editBusinessGroup = createAsyncThunk(
  "businessGroup/editBusinessGroup",
  async (payload) => {
    const response = await updateBusinessGroup(payload);
    return response;
  }
);

export const addNumberSequence = createAsyncThunk(
  "businessGroup/addNumberSequence",
  async (payload) => {
    const response = await createNumberSequence(payload);
    return response;
  }
);

export const editNumberSequence = createAsyncThunk(
  "businessGroup/editNumberSequence",
  async (payload) => {
    const response = await updateNumberSequence(payload);
    return response;
  }
);

export const removeSequence = createAsyncThunk(
  "user/removeById",
  async (id) => {
    const response = await deleteSequence(id);
    return response;
  }
);

export const addUpload = createAsyncThunk(
  "user/addUpload",
  async ({ id, file }) => {
    console.log(id, "1 slice");
    console.log(file, "file slice");
    const response = await uploadImage(id, file);
    return response;
  }
);

export const removeImage = createAsyncThunk(
  "businessGroup/removeImage",
  async (payload) => {
    const response = await deleteImage(payload);
    return response;
  }
);

export const businessGroupSlice = createSlice({
  name: "businessGroup",
  initialState,
  reducers: {
    resetData: () => initialState,
    setSelected: (state, action) => {
      state.selected = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchBusinessGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload.data.data;
      })
      .addCase(fetchNumberSequence.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchNumberSequence.fulfilled, (state, action) => {
        state.loading = false;
        state.dataSequence = action.payload.data.data;
        state.pageNo = action.payload.data.pageNo;
        state.pageSize = action.payload.data.pageSize;
        state.totalRecord = action.payload.data.totalRecord;
      })
      .addCase(fecthTz.pending, (state) => {
        state.loading = true;
      })
      .addCase(fecthTz.fulfilled, (state, action) => {
        state.loading = false;
        state.dataTz = action.payload.data.data;
      })

      .addCase(editBusinessGroup.pending, (state) => {
        state.loading = true;
      })
      .addCase(editBusinessGroup.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(addNumberSequence.pending, (state) => {
        state.loading = true;
      })
      .addCase(addNumberSequence.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(editNumberSequence.pending, (state) => {
        state.loading = true;
      })
      .addCase(editNumberSequence.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(fetchIdNumberSequence.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchIdNumberSequence.fulfilled, (state, action) => {
        state.loading = false;
        state.dataIdSequence = action.payload;
      })

      .addCase(addUpload.pending, (state) => {
        state.loading = true;
      })
      .addCase(addUpload.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      })
      .addCase(removeImage.pending, (state) => {
        state.loading = true;
      })
      .addCase(removeImage.fulfilled, (state, action) => {
        state.loading = false;
        state.result = action.payload;
      });
  },
});

export const { resetData, setSelected } = businessGroupSlice.actions;

export const selectBusinessGroup = (state) => state.businessGroup.data;
export const selectNumberSequence = (state) => state.businessGroup.dataSequence;
export const selectIdGroup = (state) => state.businessGroup.dataIdGroup;
export const selectIdSequence = (state) => state.businessGroup.dataIdSequence;
export const selectLoading = (state) => state.businessGroup.loading;
export const selectError = (state) => state.businessGroup.error;
export const selectSelected = (state) => state.businessGroup.selected;
export const selectResult = (state) => state.businessGroup.result;
export const selectTz = (state) => state.businessGroup.dataTz;
export const selectPageNo = (state) => state.businessGroup.pageNo;
export const selectPageSize = (state) => state.businessGroup.pageSize;
export const selectTotalRecord = (state) => state.businessGroup.totalRecord;

export default businessGroupSlice.reducer;
